// web/src/billing/PastDueBanner.tsx
//
// Persistent (non-dismissible) red banner shown when last payment failed.
// CTA opens Stripe Customer Portal.
import { Button } from "@/components/ui/button";
import { useSubscription, usePortalSession } from "./api";


export function PastDueBanner() {
  const sub = useSubscription();
  const portal = usePortalSession();

  if (!sub.data || sub.data.status !== "past_due") return null;

  async function openPortal() {
    const res = await portal.mutateAsync({});
    window.location.href = res.url;
  }

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-destructive/10 text-destructive text-sm">
      <span className="font-medium">
        Last payment failed — update your payment method to keep access.
      </span>
      <Button size="sm" variant="destructive" onClick={openPortal}>
        Update payment method
      </Button>
    </div>
  );
}
